import { InteractInviteEarnIcon } from '@/client/assets';
import { AuthedButton } from '@/client/components/authed-button';
import { Button } from '@/client/components/ui/button';
import { useRewardsEntry } from '@/client/hooks/use-rewards-entry';
import { cn } from '@/client/utils';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';

// More-slider rewards item: /rewards when the activity page is live,
// otherwise the legacy invite-earn page (see resolveRewardsEntry).
export const AsideInviteEarn = () => {
  const { t } = useTranslation();
  const [location, navigate] = useLocation();
  const entry = useRewardsEntry();
  if (!entry) return null;
  const isActive = location.toLowerCase().startsWith(entry.href.toLowerCase());
  // /rewards opens signed out; the legacy per-uid page asks for sign-in first.
  const EntryButton = entry.requiresAuth ? AuthedButton : Button;
  const authProps = entry.requiresAuth ? { showAuth: false, showLoading: false } : {};
  return (
    <EntryButton
      {...authProps}
      onClick={() => navigate(entry.href)}
      variant="ghost"
      className={cn(
        'w-full flex items-center justify-start md:justify-center w-full h-12 leading-5 font-medium px-3 hover:bg-foreground/5',
        isActive ? 'bg-foreground/5 font-bold' : ''
      )}
    >
      <InteractInviteEarnIcon
        className={cn('!size-5 flex-shrink-0 hover:fill-foreground', isActive ? 'fill-foreground' : 'fill-foreground/70')}
      />
      <span className="flex-1 text-left font-medium text-sm md:hidden">{t(entry.labelKey)}</span>
    </EntryButton>
  );
};
